import React from 'react';

import { Box } from 'src/design/atoms/Box';
import { Grid } from 'src/design/atoms/Grid';
import { Loader } from 'src/design/atoms/Loader';
import { Rate } from 'src/api/FiretrolApiClient';
import { useJobRates } from 'src/api/queries/rates/useJobRates';
import { Header } from 'src/design/organisms/Header';
import { useJobs } from 'src/hooks/useJobs';
import { RateSheetCard } from 'src/routes/Jobs/Tickets/WorkTicketForm/RateSheetCard/RateSheetCard';

/** RateSheetCard groups by identity, so the empty fallback must be a stable reference. */
const EMPTY_RATES: Rate[] = [];

export const Rates: React.FC = () => {
  const { selectedJob } = useJobs();
  const { data: rates = EMPTY_RATES, isLoading } = useJobRates(selectedJob?.id);

  if (!selectedJob) return null;

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob.name} - ${selectedJob.jobNumber}`,
              href: `/jobs/${selectedJob.id}/summary`,
            },
            { text: 'Rate Sheet', href: '' },
          ],
        }}
        title="Rate Sheet"
        helpText="Manage the labor, equipment and material rates available to this job."
      />
      <Grid>
        <Grid.Col span={{ base: 12, md: 8, lg: 6 }}>
          {isLoading ? (
            <Box ta="center" py="xl">
              <Loader />
            </Box>
          ) : (
            <RateSheetCard jobId={selectedJob.id} rates={rates} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};
